import React, { memo, useCallback } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import useOldStyles from './OldCheckboxButton.styled'
import useNewStyles from './CheckboxButton.styled'

const CheckboxType = props => {
	const {
		className,
		disabled,
		label,
		labelPlacement,
		value,
		useOldCheckboxes,
		checked,
		style,
		onChange,
		onKeyUp,
		onClick,
		editable,
		tabIndex,
	} = props
	const useStyles = useOldCheckboxes ? useOldStyles : useNewStyles
	const classes = useStyles(props)
	const handleClick = useCallback(() => {
		onClick(value)
	}, [onClick, value])

	return (
		<FormControlLabel
			className={clsx(className, classes.root, 'q-checkbox-label')}
			classes={{ root: classes.control, label: classes.label }}
			disabled={disabled}
			value={value}
			data-value={value}
			onChange={editable ? undefined : onChange || handleClick}
			checked={checked}
			style={style}
			control={
				<Checkbox
					className={clsx(classes.checkbox, 'q-checkbox-control')}
					disableRipple={useOldCheckboxes}
					tabIndex={tabIndex}
					inputProps={{ onKeyUp }}
					onClick={editable ? handleClick : undefined}
					checkedIcon={
						useOldCheckboxes ? (
							<div className={classes.checkedIcon}>
								<CheckBoxOutlineBlankIcon />
								<CheckIcon />
							</div>
						) : (
							undefined
						)
					}
				/>
			}
			label={label}
			labelPlacement={labelPlacement}
		/>
	)
}

CheckboxType.propTypes = {
	className: PropTypes.string,
	label: PropTypes.node,
	labelPlacement: PropTypes.oneOf(['start', 'end', 'top', 'bottom']),
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	useOldCheckboxes: PropTypes.bool,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	classes: PropTypes.shape({
		root: PropTypes.string,
		control: PropTypes.string,
		label: PropTypes.string,
		checkbox: PropTypes.string,
		checkedIcon: PropTypes.string,
	}),
	shadow: PropTypes.bool,
	onChange: PropTypes.func,
	onClick: PropTypes.func,
	onKeyUp: PropTypes.func,
	style: PropTypes.object,
	editable: PropTypes.bool,
	tabIndex: PropTypes.number,
}

CheckboxType.defaultProps = {
	labelPlacement: 'end',
	onClick: () => {},
	tabIndex: 0,
}

export default memo(CheckboxType)
